// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    anyAiModelAfter: "Any AI model",
    anyAiModelBefore: "Any AI model",
    anyAiModelBgImage: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/699c213de7f960c27bac7d9e_foundation-card-image-4.avif",
        alt: ""
    },
    anyAiModelParagraph: "Connect to leading AI models like Claude, GPT, and Gemini, with the flexibility to use the right model for each use case.",
    buttonGetStartedText: "Get Started",
    image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696f869e03cf76164acd1fa9_Group%202147203892.avif",
        alt: ""
    },
    image2: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696f87ede1f643ac12bc676e_UD.avif",
        alt: ""
    },
    image4: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696f877a2a0c0487fc535721_Sidekick%20icon.svg",
        alt: ""
    },
    image5: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696f87a563db83a92c138cc7_IK.avif",
        alt: ""
    },
    image7: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696f877a2a0c0487fc535721_Sidekick%20icon.svg",
        alt: ""
    },
    image8: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/696f87a563db83a92c138cc7_IK.avif",
        alt: ""
    },
    infiniteKnowledgeAfter: "Infinite knowledge",
    infiniteKnowledgeBefore: "Infinite knowledge",
    infiniteKnowledgeBgImage: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/699c213ddd81ffba54d9e4f3_foundation-card-image-3.avif",
        alt: ""
    },
    infiniteKnowledgeParagraph: "AI that learns from your documents, workflows, and historical data.",
    link: {
        href: "#",
        target: "_self"
    },
    openEcosystemAfter: "Open ecosystem",
    openEcosystemBefore: "Open ecosystem",
    openEcosystemParagraph: "Connect, extend, and adapt through powerful APIs, 200+ integrations, and MCP.",
    sectionParagraph: "A shared data layer that gives AI full context across people, data, and workflows.",
    sectionTagline: "AI-first foundation",
    sectionTitle: "One open, connected, and context-aware foundation ",
    unifiedDataAfter: "Unified data",
    unifiedDataBefore: "Unified <br /> data",
    unifiedDataBgImage: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/699c213da3dbfa2adcda0cb5_foundation-card-image-2.avif",
        alt: ""
    },
    unifiedDataParagraph: "Run high-volume work across departments on one ecosystem for complete visibility and alignment."
};
